import { css } from '@emotion/react';
import { FallbackRender } from '@sentry/react';
import { Trans, useTranslation } from '@frontend/i18n';
import { ErrorAccordion } from './common';
import { ErrorPage } from './error-page';

type Props = {
  primaryButtonText?: string;
  onPrimaryButtonOnClick?: () => void;
  secondaryButtonText?: string;
  onSecondaryButtonClick: () => void;
} & Parameters<FallbackRender>[0];

export const StackErrorPage = ({
  error,
  eventId,
  primaryButtonText,
  onPrimaryButtonOnClick,
  secondaryButtonText,
  onSecondaryButtonClick,
}: Props) => {
  const { t } = useTranslation();

  return (
    <section
      css={css`
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      `}
    >
      <ErrorPage
        title={t("There's Been An Error")}
        subTitle={
          <Trans t={t}>
            We ran into an error on the page you're visiting. The error has been reported. If you continue experiencing
            this issue, please call Customer Support at <a href='tel:+18885795668'>+1-888-579-5668</a>.
          </Trans>
        }
        primaryButtonText={primaryButtonText ?? t('Reload')}
        primaryButtonOnClick={onPrimaryButtonOnClick ?? (() => window.location.reload())}
        secondaryButtonText={secondaryButtonText ?? t('Go to Home Page')}
        secondaryButtonOnClick={onSecondaryButtonClick}
      />
      <ErrorAccordion error={error as Error} eventId={eventId} />
    </section>
  );
};
